import { useLayoutEffect, useRef, useState } from 'react';
const DEFAULT_MARGIN = 500;
export default function useIsNearViewport({
  margin = DEFAULT_MARGIN
} = {}) {
  const [isNearViewport, setIsNearViewport] = useState(false);
  const ref = useRef(null);
  useLayoutEffect(() => {
    const element = ref.current;
    if (!element) return;
    const rect = element.getBoundingClientRect();
    const isNear = rect.top < window.innerHeight + margin && rect.bottom > -margin;
    if (isNear) {
      setIsNearViewport(true);
      return;
    }
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsNearViewport(true);
        observer.disconnect();
      }
    }, {
      rootMargin: `${margin}px 0px`
    });
    observer.observe(element);
    return () => {
      observer.disconnect();
    };
  }, [margin]);
  return {
    ref,
    isNearViewport
  };
}